export const GET_COUNTRIES_PENDING = "GET_COUNTRIES_PENDING";
export const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_ERROR = "GET_COUNTRIES_ERROR";

export const GET_REGIONS_PENDING = "GET_REGIONS_PENDING";
export const GET_REGIONS_SUCCESS = "GET_REGIONS_SUCCESS";
export const GET_REGIONS_ERROR = "GET_REGIONS_ERROR";

export const getCountriesPending = () => ({ type: GET_COUNTRIES_PENDING });

export const getCountriesSuccess = (payload: any) => ({
  payload,
  type: GET_COUNTRIES_SUCCESS,
});

export const getCountriesError = (error: any) => ({
  type: GET_COUNTRIES_ERROR,
  error,
});

export const getRegionsPending = () => ({ type: GET_REGIONS_PENDING });

export const getRegionsSuccess = (payload: any) => ({
  payload,
  type: GET_REGIONS_SUCCESS,
});

export const getRegionsError = (error: any) => ({
  type: GET_REGIONS_ERROR,
  error,
});
